/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SuprSendJwtTokenResponse } from './SuprSendJwtTokenResponse';
import {
    SuprSendJwtTokenResponseFromJSON,
    SuprSendJwtTokenResponseFromJSONTyped,
    SuprSendJwtTokenResponseToJSON,
} from './SuprSendJwtTokenResponse';

/**
 * 
 * @export
 * @interface SuprSendGenerateJwtToken200Response
 */
export interface SuprSendGenerateJwtToken200Response {
    /**
     * 
     * @type {SuprSendJwtTokenResponse}
     * @memberof SuprSendGenerateJwtToken200Response
     */
    data?: SuprSendJwtTokenResponse;
}

/**
 * Check if a given object implements the SuprSendGenerateJwtToken200Response interface.
 */
export function instanceOfSuprSendGenerateJwtToken200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuprSendGenerateJwtToken200ResponseFromJSON(json: any): SuprSendGenerateJwtToken200Response {
    return SuprSendGenerateJwtToken200ResponseFromJSONTyped(json, false);
}

export function SuprSendGenerateJwtToken200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuprSendGenerateJwtToken200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : SuprSendJwtTokenResponseFromJSON(json['data']),
    };
}

export function SuprSendGenerateJwtToken200ResponseToJSON(value?: SuprSendGenerateJwtToken200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': SuprSendJwtTokenResponseToJSON(value.data),
    };
}

